// No need to match package structure, to force compile time switch of dependencies
class StagingFlavor : Flavor {
    override val clientName: String = "Linx-Staging"
    override val adminClientName: String = "Admin Portal-Staging"
    override val clientUrl: String = "linx-staging.enrollandpay.com"
    override val serverHttps: Boolean = true
    override val environmentName: String = "Staging"
    override val serverUrl: String = "linx-staging-west.happyisland-85986647.westus.azurecontainerapps.io"
    override val serviceServerUrl = "service-staging.enrollandpay.com"
    override val serverPort: Int? = null
    override val serviceServerPort: Int? = null
    override val databaseConnectionString: String =
        "jdbc:sqlserver://enrollandpay.database.windows.net:1433;database=EnrollAndPayV2-Staging;encrypt=true;trustServerCertificate=false;hostNameInCertificate=*.database.windows.net;loginTimeout=30;"
    override val serverBusConnectionString: String = "Endpoint=sb://enrollandpaystaging.servicebus.windows.net/;SharedAccessKeyName=RootManageSharedAccessKey;SharedAccessKey=pBFyuwKR3kvxLscp9grRBp/6WfIlyJnYgJWq9Lr5r/g="
    override val enpTerminalServerHost: String = "https://enpterminalapi-staging.azurewebsites.net/"
    override val enpServiceServerHost: String = "https://enpserviceapi-staging.azurewebsites.net/"
    override val token: String = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbnZpcm9ubWVudCI6InN0YWdpbmciLCJuYW1lIjoiZW5yb2xsYW5kcGF5In0.wKXgftCXW0180GWWB6eBlbCeV57bggh1Xzg2KWID06w"
    override val serviceApiKey: String = "4fe3b6de-138e-4ba2-ae48-b178e86d8e76"
    override val hubspotAccessToken: String? = null
    override val hubspotClientSecret: String? = null
    override val inboundServiceApiKey: String? = "ab3c7f9b-6c5c-4d1c-b084-6a8c70cc667f"
    override val portalUrl = "https://staging-portal.enrollandpay.com/"
    override val coalitionUrl = "https://staging-coalition.enrollandpay.com/"
    override val isDebug: Boolean = true
    override val alternateAdminLink: String = "https://admin.enrollandpay.com"
    override val alternateAdminTitle: String = "Prod"
    override val testHarnessUrl: String = "https://sdk-staging-west.yellowmushroom-03dd2290.westus.azurecontainerapps.io/"
    override val logSources: List<LogSource> = listOf(
        LogSource(label = "sdk-staging-west", containerAppName = "sdk-staging-west", workspaceId = "37fd1974-4ad7-4394-90b1-d8c87a2b5ddc"),
        LogSource(label = "sdk-dejavoo-staging-west", containerAppName = "sdk-dejavoo-staging-west", workspaceId = "37fd1974-4ad7-4394-90b1-d8c87a2b5ddc"),
    )
}